import { useEffect } from 'react'

import { revivalApi } from 'redux/services/revival'
import { GetRevivalParams } from 'redux/services/revival/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetRevivalParams
}

export function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = revivalApi.useLazyRevivalStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}
